module.exports = __webpack_public_path__ + "static/img/banner-bg.13e97ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner-bg.png
// module id = PiNj
// module chunks = 1